import { ComparisonEntry } from '@comparison/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { COMPARISON_DATA } from '../comparison-state';

export const COMPARISON_RESET = '[Comparison] Comparison Reset';
export const COMPARISON_ADD_ENTRY = '[Comparison] Comparison Add Entry';
export const COMPARISON_ADD_ENTRY_SUCCESS = '[Comparison] Comparison Add Entry Success';
export const COMPARISON_ADD_ENTRY_ERROR = '[Comparison] Comparison Add Entry Error';
export const COMPARISON_REMOVE_ENTRY = '[Comparison] Comparison Remove Entry';
export const COMPARISON_REMOVE_CATEGORY = '[Comparison] Comparison Remove Category';
export const COMPARISON_SET_STATE = '[Comparison] Comparison Set State';
export const COMPARISON_SET_ACTIVE_CATEGORY = '[Comparison] Comparison Set Active Category';
export const COMPARISON_CATEGORIES_LIMIT_EXCEEDED = '[Comparison] Comparison Categories Limit Exceeded';
export const COMPARISON_PRODUCTS_LIMIT_EXCEEDED = '[Comparison] Comparison Products Limit Exceeded';

export class ComparisonAddEntry implements Action {
  readonly type = COMPARISON_ADD_ENTRY;

  constructor(public payload: { productId: string }) {}
}

export class ComparisonAddEntrySuccess implements Action {
  readonly type = COMPARISON_ADD_ENTRY_SUCCESS;

  constructor(public payload: { productId: string; entry: ComparisonEntry }) {}
}

export class ComparisonAddEntryError implements Action {
  readonly type = COMPARISON_ADD_ENTRY_ERROR;

  constructor(public payload: { productId: string }) {}
}

export class ComparisonRemoveEntry implements Action {
  readonly type = COMPARISON_REMOVE_ENTRY;

  constructor(public payload: { productId: string }) {}
}

export class ComparisonRemoveCategory implements Action {
  readonly type = COMPARISON_REMOVE_CATEGORY;

  constructor(public payload: { code: string }) {}
}

export class ComparisonReset extends StateUtils.EntityRemoveAllAction {
  readonly type = COMPARISON_RESET;

  constructor() {
    super(COMPARISON_DATA);
  }
}

export class ComparisonSetState implements Action {
  readonly type = COMPARISON_SET_STATE;

  constructor(public payload: any) {}
}

export class ComparisonSetActiveCategory implements Action {
  readonly type = COMPARISON_SET_ACTIVE_CATEGORY;

  constructor(public payload: string) {}
}

export class ComparisonCategoriesLimitExceeded implements Action {
  readonly type = COMPARISON_CATEGORIES_LIMIT_EXCEEDED;

  constructor(public payload: { productId: string; maxLimit: number }) {}
}

export class ComparisonProductsLimitExceeded implements Action {
  readonly type = COMPARISON_PRODUCTS_LIMIT_EXCEEDED;

  constructor(public payload: { productId: string; maxLimit: number }) {}
}

export type ComparisonActions =
  | ComparisonReset
  | ComparisonAddEntry
  | ComparisonAddEntrySuccess
  | ComparisonAddEntryError
  | ComparisonRemoveEntry
  | ComparisonRemoveCategory
  | ComparisonSetState
  | ComparisonSetActiveCategory
  | ComparisonCategoriesLimitExceeded
  | ComparisonProductsLimitExceeded;
